<app-page-shell [title]="'dashboard_title' | translate" [description]="'dashboard_desc' | translate">
  <div class="space-y-8" *ngIf="canAccessDashboard$ | async; else noPermission">

    <!-- DESKTOP UI (unchanged) -->
    <div class="hidden md:block space-y-8">


      <!-- Top Stats: Online Users & Revenue Today -->
      <div class="grid grid-cols-2 gap-4 sm:gap-6">
        <!-- People Logged In (Online Users) -->
        <div *ngIf="userStatus$ | async as status" class="contents">
          <div *ngIf="status === 'all'"
            class="bg-white rounded-3xl p-4 sm:p-6 shadow-sm border border-slate-100 flex flex-col justify-between">
            <div class="flex items-center justify-between mb-4">
              <div class="p-3 bg-primary/10 rounded-xl">
                <svg class="w-6 h-6 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
            </div>
            <div>
              <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 truncate">{{
                'dashboard_online_users'
                | translate }}</p>
              <h3 class="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">{{ onlineUsers$ | async }}</h3>
            </div>
          </div>
        </div>

        <!-- Today's Revenue (Receipt) -->
        <div *ngIf="hasPermission('Financeiro') | async"
          class="bg-white rounded-3xl p-4 sm:p-6 shadow-sm border border-slate-100 flex flex-col justify-between">
          <div class="flex items-center justify-between mb-4">
            <div class="p-3 bg-success/10 rounded-xl">
              <svg class="w-6 h-6 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
          <div *ngIf="paymentsSummary$ | async as summary; else loadingRevenue">
            <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 truncate">{{
              'dashboard_revenue_today' |
              translate }}</p>
            <h3 class="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight">€ {{
              formatMoney(summary.total_entries) }}</h3>
          </div>
          <ng-template #loadingRevenue>
            <div class="animate-pulse h-10 bg-slate-100 rounded w-32"></div>
          </ng-template>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="grid grid-cols-1 lg:grid-cols-5 gap-8">
        <!-- Appointment Status (Pie Chart) -->
        <div class="lg:col-span-2 bg-white rounded-3xl p-4 sm:p-8 shadow-sm border border-slate-100 flex flex-col">
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6 flex-shrink-0">
            <h3 class="text-sm font-black text-slate-900 uppercase tracking-widest">{{ 'dashboard_appointment_status' |
              translate }}</h3>
            <app-dropdown>
              <ng-template #trigger>
                <button
                  class="flex items-center gap-3 px-4 py-2 bg-slate-50 border border-slate-200 rounded-xl text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-100 transition-all shadow-sm">
                  {{ getPeriodTranslationKey(selectedPeriod) | translate }}
                  <i class="pi pi-chevron-down text-[9px] opacity-40"></i>
                </button>
              </ng-template>
              <ng-template #content>
                <div class="flex flex-col py-1 min-w-[140px]">
                  <button *ngFor="let p of ['Diário', 'Semanal', 'Mensal', 'Trimestral']" (click)="onPeriodChange(p)"
                    class="px-5 py-3 text-left text-[10px] font-black uppercase tracking-widest transition-colors flex items-center justify-between gap-4"
                    [class.text-primary]="selectedPeriod === p" [class.bg-primary/5]="selectedPeriod === p"
                    [class.text-slate-600]="selectedPeriod !== p" [class.hover:bg-slate-50]="selectedPeriod !== p">
                    {{ getPeriodTranslationKey(p) | translate }}
                    <i *ngIf="selectedPeriod === p" class="pi pi-check text-[10px]"></i>
                  </button>
                </div>
              </ng-template>
            </app-dropdown>
          </div>

          <div class="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-4 py-4 flex-1 min-h-0">
            <ng-container *ngIf="(activeAppointmentStats$ | async) as activeStats">
              <ng-container *ngIf="activeStats.length; else emptyStatusDesktop">
                <!-- Legend (Left) -->
                <div class="flex-1 w-full grid grid-cols-1 gap-y-2 pr-2 overflow-y-auto min-h-0">
                  <div *ngFor="let stat of activeStats" class="flex items-center text-sm">
                    <div class="flex items-center gap-2 min-w-0 w-full">
                      <div class="w-2.5 h-2.5 rounded-full flex-shrink-0 shadow-sm"
                        [style.backgroundColor]="stat.color_bg || '#000000'"></div>
                      <span
                        class="text-slate-600 truncate text-[10px] font-black uppercase tracking-wider block flex-1">{{
                        getAppointmentStatusKey(stat.status_name) | translate }}</span>
                    </div>
                  </div>
                </div>

                <!-- Pie Chart (Right) -->
                <div class="relative w-48 h-48 sm:w-44 sm:h-44 flex-shrink-0 flex items-center justify-center">
                  <p-chart type="doughnut" [data]="chartData" [options]="chartOptions"
                    class="w-full h-full flex justify-center items-center"></p-chart>
                </div>
              </ng-container>
            </ng-container>

            <!-- Empty state: no appointments in the selected period -->
            <ng-template #emptyStatusDesktop>
              <div class="flex flex-col items-center justify-center gap-3 py-8 text-center w-full">
                <svg class="w-10 h-10 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span class="text-slate-400 font-medium text-xs">{{ 'dashboard_no_appointments' | translate }}</span>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Checking Account (Line Chart) -->
        <div *ngIf="hasPermission('Financeiro') | async"
          class="lg:col-span-3 bg-white rounded-3xl p-4 sm:p-8 shadow-sm border border-slate-100 relative">
          <!-- Header: Matching Reference Image Exactly -->
          <h3 class="text-sm font-black text-slate-900 mb-6 uppercase tracking-widest">{{ 'dashboard_checking_account' |
            translate }}</h3>
          <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
            <!-- Legend (Left) -->
            <div
              class="flex flex-shrink-0 items-center gap-3 px-5 py-2.5 border-2 border-primary rounded-2xl bg-primary/5">
              <div class="w-3 h-3 rounded-full bg-primary shadow-sm"></div>
              <span class="text-[10px] font-black text-primary uppercase tracking-widest">{{ 'dashboard_income' |
                translate }}</span>
            </div>
            <!-- Date Range Trigger (Right) -->
            <button (click)="toggleDatePicker()"
              class="flex w-full sm:w-auto justify-center items-center gap-3 px-5 py-2.5 border border-slate-200 rounded-2xl shadow-sm hover:bg-slate-50 transition-all text-[10px] font-black text-slate-600 uppercase tracking-widest">
              <svg class="w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              {{ chartStartDate | date:'dd/MM' }} - {{ chartEndDate | date:'dd/MM' }}
            </button>
          </div>



          <!-- Plot Area with Precise Y-Axis Formatting -->
          <div class="h-72 flex overflow-x-auto w-full scrollbar-thin pb-4" *ngIf="{ 
          max: (maxChartValue$ | async) || 1000, 
          transactions: (weeklyTransactions$ | async) || [] 
        } as chartData">
            <!-- Y-Axis (Left aligned with specific formatting) -->
            <div
              class="flex flex-col justify-between py-1 h-[240px] text-xs font-medium text-slate-500 w-16 sm:w-32 pr-2 sm:pr-4 text-right flex-shrink-0 sticky left-0 bg-white z-10">
              <span>{{ formatMoney(chartData.max) }} €</span>
              <span>{{ formatMoney(chartData.max / 2) }} €</span>
              <span>0,00 €</span>
            </div>

            <!-- Chart Content -->
            <div class="flex-1 h-[240px] relative min-w-[500px]">
              <!-- Grid Lines -->
              <div class="absolute inset-x-0 h-[1px] border-t border-dashed border-slate-200" style="top: 0%"></div>
              <div class="absolute inset-x-0 h-[1px] border-t border-dashed border-slate-200" style="top: 50%"></div>
              <div class="absolute inset-x-0 h-[1px] border-t border-dashed border-slate-200" style="bottom: 0%"></div>

              <!-- Vertical Bars -->
              <div class="absolute inset-0 flex items-end px-1 h-[240px]"
                [class.justify-between]="chartData.transactions.length > 15">
                <div *ngFor="let day of chartData.transactions"
                  class="group relative flex-1 flex justify-center h-full items-end"
                  [style.max-width.%]="100 / chartData.transactions.length">
                  <div class="bg-primary rounded-t-sm transition-all duration-300 hover:brightness-110 shadow-sm"
                    [style.height.%]="((day.total_entrada || 0) / chartData.max) * 100"
                    [style.width.px]="chartData.transactions.length > 30 ? 2 : (chartData.transactions.length > 15 ? 4 : 8)"
                    style="min-height: 1px;">
                    <!-- Tooltip -->
                    <div
                      class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-slate-900 text-white text-[10px] rounded py-1.5 px-3 whitespace-nowrap z-50 shadow-xl">
                      {{ (day.date || day.day_of_week) | date:'dd/MM/yyyy' }}: <strong>€ {{
                        formatMoney(day.total_entrada)
                        }}</strong>
                    </div>
                  </div>
                </div>
              </div>

              <!-- X-Axis Labels (Sparse and Rotated) -->
              <div class="absolute top-[240px] inset-x-0 flex justify-between pr-4 h-12 pt-6">
                <ng-container *ngFor="let day of chartData.transactions; let i = index">
                  <div *ngIf="i % getXAxisInterval(chartData.transactions.length) === 0"
                    class="text-[11px] font-black text-slate-400 transform -rotate-45 origin-top-left -translate-x-4 whitespace-nowrap uppercase tracking-widest">
                    {{ (day.date || day.day_of_week) | date:'dd/MM' }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Current Account Summary: Refactored with AppTable -->
      <div *ngIf="hasPermission('Financeiro') | async"
        class="bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden">
        <div class="p-6 border-b border-slate-50 flex justify-between items-center">
          <h3 class="text-sm font-black text-slate-900 uppercase tracking-widest">{{ 'dashboard_account_summary' |
            translate }}</h3>
        </div>

        <div class="overflow-x-auto w-full">
          <app-prime-table [columns]="summaryColumns" [data]="(expenseRecords$ | async) || []" [paginator]="false"
            [templates]="summaryTemplates" [rows]="10" class="min-w-[600px] block">
          </app-prime-table>
        </div>
      </div>

    </div>


  </div>

  <!-- ======================= -->
  <!-- COMPLETELY REDESIGNED MOBILE UI -->
  <!-- ======================= -->
  <div class="block md:hidden flex flex-col gap-6 w-full max-w-[100vw] overflow-hidden px-1 pb-20">

    <!-- HEADER HERO (Unified Premium Top Card) -->
    <div
      class="bg-gradient-to-br from-primary to-blue-600 rounded-[32px] p-8 text-white shadow-xl shadow-primary/20 relative overflow-hidden flex flex-col gap-6">
      <!-- Abstract glassmorphism shapes -->
      <div class="absolute -right-8 -top-8 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
      <div class="absolute -left-12 -bottom-12 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>

      <!-- Main Highlight -->
      <div *ngIf="hasPermission('Financeiro') | async" class="relative z-10 flex flex-col gap-2">
        <span class="text-[10px] font-black text-blue-100 uppercase tracking-widest opacity-80">{{
          'dashboard_revenue_today' | translate }}</span>
        <div *ngIf="paymentsSummary$ | async as summary; else loadingRevM" class="flex items-center gap-1">
          <h2 class="text-4xl sm:text-5xl font-black tracking-tight leading-none drop-shadow-sm">€{{
            formatMoney(summary.total_entries) }}</h2>
        </div>
        <ng-template #loadingRevM>
          <div class="animate-pulse h-12 bg-white/20 rounded-xl w-48 mt-1"></div>
        </ng-template>
      </div>

      <div class="h-[1px] w-full bg-white/20 relative z-10"></div>

      <!-- Secondary Meta (Online Users) -->
      <div *ngIf="userStatus$ | async as status" class="relative z-10">
        <div *ngIf="status === 'all'" class="flex items-center justify-between">
          <span class="text-xs font-bold text-blue-100 flex items-center gap-2">
            <svg class="w-4 h-4 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            {{ 'dashboard_online_users' | translate }}
          </span>
          <div
            class="flex items-center gap-2 bg-black/20 backdrop-blur-md px-4 py-1.5 rounded-full border border-white/10 shadow-inner">
            <div class="w-2 h-2 rounded-full bg-green-400 animate-pulse shadow-[0_0_8px_rgba(74,222,128,0.8)]"></div>
            <span class="text-sm font-black text-white">{{ onlineUsers$ | async }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- APPOINTMENT STATUS (Sleek Horizontal Scroll & Clean Donut) -->
    <div class="flex flex-col gap-4">
      <div class="flex items-center justify-between px-2">
        <h3 class="text-sm font-black text-slate-800 uppercase tracking-widest">{{ 'dashboard_appointment_status' |
          translate }}</h3>
        <app-dropdown menuClass="!rounded-3xl">
          <ng-template #trigger>
            <button
              class="bg-slate-100 text-[10px] font-black uppercase tracking-widest border-none rounded-full py-2 px-4 text-slate-600 flex items-center gap-2 active:scale-95 transition-transform">
              {{ getPeriodTranslationKey(selectedPeriod) | translate }}
              <i class="pi pi-chevron-down text-[8px] opacity-40"></i>
            </button>
          </ng-template>
          <ng-template #content>
            <div class="flex flex-col py-2 min-w-[160px]">
              <button *ngFor="let p of ['Diário', 'Semanal', 'Mensal', 'Trimestral']" (click)="onPeriodChange(p)"
                class="px-6 py-4 text-left text-[11px] font-black uppercase tracking-widest transition-colors flex items-center justify-between"
                [class.text-primary]="selectedPeriod === p" [class.bg-primary/5]="selectedPeriod === p"
                [class.text-slate-600]="selectedPeriod !== p">
                {{ getPeriodTranslationKey(p) | translate }}
                <i *ngIf="selectedPeriod === p" class="pi pi-check text-[10px]"></i>
              </button>
            </div>
          </ng-template>
        </app-dropdown>
      </div>

      <div
        class="bg-white rounded-3xl p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-50 flex flex-col gap-6">
        <ng-container *ngIf="(activeAppointmentStats$ | async) as activeStatsM">
          <ng-container *ngIf="activeStatsM.length; else emptyStatusMobile">
            <div class="relative w-full aspect-square max-w-[200px] mx-auto flex items-center justify-center">
              <p-chart type="doughnut" [data]="chartData" [options]="chartOptions"
                class="w-full h-full flex justify-center items-center drop-shadow-md"></p-chart>
            </div>

            <div class="flex flex-wrap gap-2 items-center justify-center">
              <div *ngFor="let stat of activeStatsM"
                class="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-slate-50 border border-slate-100 transition-transform active:scale-95">
                <div class="w-2 h-2 rounded-full shadow-sm" [style.backgroundColor]="stat.color_bg || '#000000'"></div>
                <span class="text-slate-600 text-[9px] font-black uppercase tracking-wider">{{ getAppointmentStatusKey(stat.status_name) | translate }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Empty state: no appointments in the selected period -->
        <ng-template #emptyStatusMobile>
          <div class="flex flex-col items-center justify-center gap-3 py-10 text-center">
            <svg class="w-10 h-10 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span class="text-slate-400 font-medium text-xs">{{ 'dashboard_no_appointments' | translate }}</span>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- CHECKING ACCOUNT (Borderless Line Chart Integration) -->
    <div *ngIf="hasPermission('Financeiro') | async" class="flex flex-col gap-4 mt-2">
      <div class="flex items-center justify-between px-2">
        <h3 class="text-sm font-black text-slate-800 uppercase tracking-widest">{{ 'dashboard_checking_account' |
          translate }}</h3>
        <button (click)="toggleDatePicker()"
          class="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-600 hover:bg-slate-200 transition-colors">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </button>
      </div>

      <!-- Date span indicator -->
      <div class="px-2">
        <span class="text-xs font-bold text-slate-400">{{ chartStartDate | date:'dd MMM' }} — {{ chartEndDate | date:'dd
          MMM yyyy' }}</span>
      </div>

      <!-- Mobile Chart rendering -->
      <div class="bg-white rounded-3xl p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-50"
        *ngIf="{ max: (maxChartValue$ | async) || 1000, transactions: (weeklyTransactions$ | async) || [] } as chartData">
        <div class="flex items-center gap-2 mb-6">
          <div class="w-2.5 h-2.5 rounded-full bg-primary shadow-[0_0_8px_rgba(59,130,246,0.5)]"></div>
          <span class="text-[9px] font-black text-slate-400 uppercase tracking-widest">{{ 'dashboard_income' | translate
            }}</span>
        </div>

        <!-- Scrollable Minimal Chart -->
        <div class="h-48 flex overflow-x-auto w-full scrollbar-none pb-2 relative">
          <!-- Transparent Y Axis anchored left -->
          <div
            class="flex flex-col justify-between py-1 h-[140px] text-[9px] font-bold text-slate-300 w-12 pr-2 text-right flex-shrink-0 sticky left-0 z-10 bg-white/90 backdrop-blur-sm">
            <span>{{ formatMoney(chartData.max/1000) }}k</span>
            <span>{{ formatMoney(chartData.max/2000) }}k</span>
            <span>0</span>
          </div>

          <div class="flex-1 h-[140px] relative min-w-[400px]">
            <div class="absolute inset-x-0 h-[1px] border-t border-dashed border-slate-100" style="top: 0%"></div>
            <div class="absolute inset-x-0 h-[1px] border-t border-dashed border-slate-100" style="top: 50%"></div>
            <div class="absolute inset-x-0 h-[1px] border-t border-dashed border-slate-100" style="bottom: 0%"></div>

            <div class="absolute inset-0 flex items-end px-1 h-[140px]"
              [class.justify-between]="chartData.transactions.length > 7">
              <div *ngFor="let day of chartData.transactions"
                class="group relative flex-1 flex justify-center h-full items-end"
                [style.max-width.%]="100 / chartData.transactions.length">
                <div class="bg-primary rounded-t-lg transition-all duration-300 active:brightness-110"
                  [style.height.%]="((day.total_entrada || 0) / chartData.max) * 100"
                  [style.width.px]="chartData.transactions.length > 20 ? 4 : (chartData.transactions.length > 10 ? 8 : 14)"
                  style="min-height: 2px;">
                </div>
              </div>
            </div>

            <div class="absolute top-[148px] inset-x-0 flex justify-between pr-2 h-8">
              <ng-container *ngFor="let day of chartData.transactions; let i = index">
                <div *ngIf="i % getXAxisInterval(chartData.transactions.length) === 0"
                  class="text-[8px] font-bold text-slate-400 uppercase tracking-widest">
                  {{ (day.date || day.day_of_week) | date:'dd/MM' }}
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- RECENT OPERATIONS (Account Summary mapped cleanly) -->
    <div *ngIf="hasPermission('Financeiro') | async" class="flex flex-col gap-4 mt-4">
      <div class="flex items-center justify-between px-2">
        <h3 class="text-sm font-black text-slate-800 uppercase tracking-widest">{{ 'dashboard_account_summary' |
          translate }}</h3>
      </div>
      <app-mobile-card-list [columns]="summaryColumns" [data]="(expenseRecords$ | async) || []"
        [templates]="summaryTemplates" [lazy]="false"></app-mobile-card-list>
    </div>

  </div>

  <!-- DATE RANGE FILTER MODAL / BOTTOM SHEET (GLOBAL) -->
  <div *ngIf="showDatePicker"
    class="fixed inset-0 z-[200] flex items-end sm:items-center justify-center bg-slate-900/40 backdrop-blur-sm sm:backdrop-blur-[2px] transition-all p-0 sm:p-4">

    <div
      class="bg-white w-full sm:w-[540px] max-h-[90vh] sm:rounded-[32px] rounded-t-[32px] rounded-b-none shadow-2xl flex flex-col overflow-hidden animate-in slide-in-from-bottom-full sm:zoom-in-95 duration-300">

      <!-- Mobile drag handle indicator -->
      <div class="w-full flex justify-center pt-3 pb-1 sm:hidden">
        <div class="w-12 h-1.5 rounded-full bg-slate-200"></div>
      </div>

      <!-- Header -->
      <div class="flex items-center justify-between px-6 sm:px-8 py-4 sm:py-6 border-b border-slate-100/50">
        <h4 class="font-black text-slate-800 flex items-center gap-3 uppercase tracking-widest text-sm">
          <div class="w-2.5 h-2.5 rounded-full bg-primary shadow-sm shadow-primary/30"></div>
          {{ 'dashboard_select_period' | translate }}
        </h4>
        <button (click)="toggleDatePicker()"
          class="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Scrollable content body -->
      <div class="flex-1 overflow-y-auto p-6 sm:p-8 flex flex-col gap-8">
        <!-- Quick Presets -->
        <div class="flex flex-row overflow-x-auto gap-2 scrollbar-none pb-2 -mx-2 px-2">
          <button
            *ngFor="let preset of ['period_today', 'period_last_7_days', 'period_last_30_days', 'period_this_month', 'period_last_month']"
            (click)="setPresetRange(preset)"
            class="flex-shrink-0 px-4 py-2 rounded-2xl text-[10px] font-bold uppercase tracking-widest transition-colors border"
            [class.bg-primary/10]="activePreset === preset" [class.text-primary]="activePreset === preset"
            [class.border-primary/20]="activePreset === preset" [class.bg-white]="activePreset !== preset"
            [class.text-slate-500]="activePreset !== preset" [class.border-slate-200]="activePreset !== preset">
            {{ preset | translate }}
          </button>
        </div>

        <!-- Custom Date Range -->
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col gap-2">
            <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">{{
              'dashboard_start_date' | translate }}</label>
            <input type="date" [(ngModel)]="chartStartDate"
              class="w-full bg-slate-50 border border-slate-100 rounded-2xl text-xs py-3.5 px-4 font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-primary/10 focus:border-primary shadow-sm transition-all outline-none">
          </div>
          <div class="flex flex-col gap-2">
            <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">{{ 'dashboard_end_date'
              | translate }}</label>
            <input type="date" [(ngModel)]="chartEndDate"
              class="w-full bg-slate-50 border border-slate-100 rounded-2xl text-xs py-3.5 px-4 font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-primary/10 focus:border-primary shadow-sm transition-all outline-none">
          </div>
        </div>
      </div>

      <!-- Action Footer -->
      <div class="p-4 sm:p-6 bg-slate-50 border-t border-slate-100"
        style="padding-bottom: calc(1.5rem + var(--sab, 0px))">
        <button (click)="onDateRangeChange(chartStartDate, chartEndDate); toggleDatePicker()"
          class="w-full py-4 bg-primary text-white rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-primary-hover shadow-xl shadow-primary/20 transition-all active:scale-[0.98]">
          {{ 'common_apply' | translate }}
        </button>
      </div>

    </div>
  </div>

  <ng-template #noPermission>
    <app-no-permission></app-no-permission>
  </ng-template>
</app-page-shell>

<!-- Templates for Dashboard Summary Table -->
<ng-template #patientTemplate let-row>
  <div class="flex items-center gap-3">
    <img [appSignedSrc]="row.patient_photo" bucket="patient_documents"
      class="w-8 h-8 rounded-full border border-slate-100 object-cover shadow-sm">
    <span class="text-sm font-black text-slate-900 tracking-tight">{{ row.patient_name || '-' }}</span>
  </div>
</ng-template>

<ng-template #valueTemplate let-row>
  <span class="text-sm font-black text-success tracking-tight">€ {{ formatMoney(row.gross_value) }}</span>
</ng-template>

<ng-template #appointmentStatusTemplate let-row>
  <span class="px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-widest shadow-sm"
    [style.backgroundColor]="row.status_bg_color || '#f1f5f9'" [style.color]="row.status_text_color || '#64748b'">
    {{ row.appointment_status ? (getAppointmentStatusKey(row.appointment_status) | translate) : '-' }}
  </span>
</ng-template>

<ng-template #paymentStatusTemplate let-row>
  <span class="px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-widest shadow-sm"
    [ngClass]="getPaymentStatusClass(row.status_name)">
    {{ row.status_name ? (getFinancialStatusKey(row.status_name) | translate) : '-' }}
  </span>
</ng-template>